export const defaultSettingsItems = [
  {
    menuItem: "Your profile",
    path: "/profile",
    icon: { source: "settingsNav", name: "Your profile" },
  },
  {
    menuItem: "Organisation details",
    path: "/organisationDetails",
    icon: { source: "settingsNav", name: "Organisation details" },
  },
  {
    menuItem: "Integrations",
    path: "/configure/integrations",
    icon: { source: "configureDropdown", name: "Integrations" },
  },
  {
    menuItem: "Platform Settings",
    path: "/platformSettings",
    icon: { source: "settingsNav", name: "Platform Settings" },
  },
  {
    menuItem: "Configure billing",
    path: "/settings/configurebilling/",
    ddItems: [
      {
        menuItem: "Billing units",
        path: "/settings/configurebilling/billingunits",
        icon: { source: "configureBillingDropdown", name: "Billing unit" },
      },
      {
        menuItem: "Usage sources",
        path: "/settings/configurebilling/usageSources",
        icon: { source: "configureBillingDropdown", name: "Usage sources" },
      },
      {
        menuItem: "Usage compilation",
        path: "/settings/configurebilling/usageCompilation",
        icon: { source: "configureBillingDropdown", name: "Usage compilation" },
      },
      {
        menuItem: "Usage collection",
        path: "/settings/configurebilling/usageCollection",
        icon: { source: "configureBillingDropdown", name: "Usage collection" },
      },
      {
        menuItem: "System features",
        path: "/settings/configurebilling/systemFeatures",
        icon: { source: "configureBillingDropdown", name: "System features" },
      },
      {
        menuItem: "Billing logic",
        path: "/settings/configurebilling/billingLogic",
        icon: { source: "settingsNav", name: "Billing logic" },
      },
      {
        menuItem: "Configure Self-checkout",
        path: "/selfservecheckout/configure",
        icon: { source: "settingsNav", name: "Configure Self-checkout" },
      },
    ],
  },

  {
    menuItem: "Users & Roles",
    path: "/settings/userManagement",
    ddItems: [
      {
        menuItem: "User management",
        path: "/settings/userManagement",
        icon: { source: "settingsNav", name: "User management" },
      },
      {
        menuItem: "Roles",
        path: "/settings/roles",
        icon: { source: "settingsNav", name: "Roles & Permissions" },
      },
      {
        menuItem: "Permissions",
        path: "/settings/permissions",
        icon: { source: "settingsNav", name: "Permissions" },
      },
    ],
  },

  {
    menuItem: "Imports & Exports",
    path: "/settings/imports",
    ddItems: [
      {
        menuItem: "Imports",
        path: "/settings/imports",
        icon: { source: "settingsNav", name: "Imports" },
      },
      {
        menuItem: "Migrations",
        path: "/settings/migrations",
        icon: { source: "settingsNav", name: "Migrations" },
      },
      {
        menuItem: "Exports",
        path: "/settings/exports",
        icon: { source: "settingsNav", name: "Exports" },
      },
    ],
  },

  {
    menuItem: "Customizations",
    path: "/settings/customizations",
    ddItems: [
      {
        menuItem: "Document management",
        path: "/settings/documentManagement",
        icon: { source: "settingsNav", name: "Document management" },
      },

      {
        menuItem: "Object customization",
        path: "/settings/objectCustomization",
        icon: { source: "settingsNav", name: "Object customization" },
      },

      {
        menuItem: "Webhooks",
        path: "/configure/webhooks",
        icon: { source: "configureDropdown", name: "Webhooks" },
      },

      {
        menuItem: "Time Machine",
        path: "/configure/time-machine",
        icon: { source: "configureDropdown", name: "Time Machine" },
      },
    ],
  },
];
